import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterSingleDate_template} from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSingleDate_template';
import {transactionsComparison_template} from './transactionsComparison_template'

declare var ko: any;

export class transactionsRecurringEdit_template extends vnTemplate {

    public datePicker: filterSingleDate_template;
    private allowedPayrollEntryTypes = [3,4,7,10,];
    private allowedNonPayrollEntryTypes = [1,2,3,4,5,6,7,8,11,12];

    protected getTemplateHtml(): string {

        return `
                <div class="form-header">
                    <input id="user-id" data-bind="value: id" type="hidden">
                    <h3 class="form-title icon i-user-add"><span data-bind="text: infoTitle"></span><span>&nbsp;  Rule</span></h3>
                    <button data-bind="event: { click: onClickCancel }" class="close-button icon i-close-2"><span class="hidden-text">close</span></button>
                </div>
                
                <div class="w-form-body">
                    <div class="form-body">
                        
                        <strong class="form-sub-title">Payment Information</strong>
    
                        <div class="form-group icon i-auto-complete">
                            <label class="form-label" for="idUser">user</label>
                            <input id="idUser" autocomplete="off" data-bind="event: { input: onChangeUserInput }, textInput: user, valueUpdate : 'input'" list="users" class="input-text">
                                <ul class="form-auto-list" data-bind="foreach: users, visible: isShowUserSuggestions" id="users">
                                    <li class="form-auto-item" data-bind="attr:{id:id}, text: $data.valnet_user.fullNameAndLogin, click: $parent.onBlurUser" ></li>
                                </ul>
                            </input>
                        </div>
                        
                         <div class="form-group row">
                            <label class="form-label" for="accountType">Account</label>
                            <select id="accountType" data-bind="options: options_accounts,  event:{ change: onAccountChange }, value: idAccount, optionsCaption: 'Select', optionsText: 'name', optionsValue: 'id', valueAllowUnset: true">
                            </select>
                        </div>
                        
                        <div class="form-group row">
                            <label for="entryType" class="form-label">Entry Type</label>
                            <select id="entryType" data-bind="options: options_entryTypes, value: idEntryType, optionsCaption: 'Select', optionsText: 'name', optionsValue: 'id', valueAllowUnset: true">
                            </select>
                        </div>
                        
                        <div class="form-group row">
                            <label for="salaryType" class="form-label">Item Type</label>
                            <select id="salaryType" data-bind="options: options_itemTypes, value: idItemType, optionsCaption: 'Select', optionsText: 'name', optionsValue: 'id', valueAllowUnset: true">
                            </select>
                        </div>
                        
                        <div class="form-group">
                            <hr class="form-hr">
                        </div>

                        
                        
                        <div class="form-group row">
                            <label class="form-label" for="frequency" class="label-oneline">Frequency<span>*</span></label>
                            <select id="frequency" data-bind="options: options_frequency, value: selectedFrequency, optionsCaption: 'Select', optionsText: 'name', optionsValue: 'id', valueAllowUnset: true">
                            </select>
                        </div>
                        <div class="form-group" style="display: none;" >
                            <input id="generateTransaction" data-bind="checked: generateTransaction" type="checkbox">
                            <label class="form-label icon i-check" for="generateTransaction">Generate Transaction Immediately?</label>
                            <small class="form-error"></small>
                        </div>
                    </div>
                    
                    <div class="form-body">
                        
                        <strong class="form-sub-title">Accounting Information</strong>
                        
                       
                        
                        <div class="form-group row">
                            <label for="idRole" class="form-label">Role</label>
                            <select id="idRole" data-bind="options: options_roles, optionsText: 'name', value: idRole, optionsValue: 'id', optionsCaption: 'Select', valueAllowUnset: true">
                            </select>
                        </div>
                        
                        <div class="form-group">
                            <label class="form-label" for="amount">amount</label>
                            <input id="amount" data-bind="value: amount" type="text" class="input-text">
                        </div>
                        
                        <div class="form-group">
                            <label class="form-label" for="note">Note</label>
                            <input id="note" maxlength="50" data-bind="value: note" type="text" class="input-text">
                            <small class="form-error"></small>
                        </div> 
                        
                        <div class="form-group" data-bind="visible: showValnetSupportSplit()">
                            <input data-bind="value: valnetSupportSplit, checked: valnetSupportSplit, event:{ change: $parent.onChangeValnetDynamicSplit }" type="checkbox" id="valnetSupportSplit">
                            <label class="form-label icon i-check" for="valnetSupportSplit">Valnet Support Split</label>
                        </div>
                        
                        <div class="form-group" >
                             <div class="w-add-rec-trans dropdown">
                                
                                <button type="button" class="btn border dropdown-toggle icon i-dropdown-simple" data-bind="event: { mouseover: showBrandSelector, mouseout: hideBrandSelector }, visible: !valnetSupportSplit()">Brands</button>
                                <div class="add-rec-trans is-visible" data-bind="foreach: brands, visible: isBrandSelectorShown, event: { mouseover: showBrandSelector, mouseout: hideBrandSelector }">
                                <!-- is-visible -->                                                               
                                    <div class="form-group row">
                                        <input data-bind="value: id, checked: checked, attr:{id: 'brand_' + id}, css: { 'read-only': $parent.valnetSupportSplit }" type="checkbox">
                                        <label class="form-label icon i-check" data-bind="text: name, attr:{for: 'brand_' + id}"></label>
                                        <input class="input-text" type="text" data-bind="value: percentageAttribution, css: { 'read-only': $parent.valnetSupportSplit }">
                                        <span>%</span>
                                    </div>     
                                </div>
                             </div>
                        </div>
                        
                        <div class="form-group">
                            <dl class="double-list" >
                                <dt><span>currency:</span></dt>
                                <dd data-bind="text: currency"></dd>
                            </dl>
                        </div>
                        
                    </div>
                    
                </div>
                
                <div class="form-footer">
                    <button data-bind="event: { click: onClickCancel }" class="btn" type="button">Cancel</button>
                    <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save</button>
                </div>
            `;
    }

    protected initPartial(): void {
    }

    protected getTemplateName(): string {
        return "transactionsRecurringEdit-form-template";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-form", "w-form-large"];
    }


    protected buildViewModel(): any {

        let self = this;
        return {
            id: ko.observable(""),
            amount: ko.observable(""),
            note: ko.observable(""),
            actionType: ko.observable(""),
            creationType: ko.observable(""),
            currency: ko.observable(""),
            brands: ko.observableArray([]),
            allBrands: ko.observableArray([]),
            selectedBrands: ko.observableArray([]),
            selectedBrandsPercentages: ko.observableArray([]),
            options_status: ko.observable([]),
            options_brands: ko.observableArray([]),
            options_currencies: ko.observableArray([]),
            idCurrency: ko.observable(),
            options_actionTypes: ko.observableArray([]),
            idActionType: ko.observable(),
            generateTransaction: ko.observable(false),
            options_roles: ko.observableArray([]),
            idRole: ko.observable(),
            options_types: ko.observableArray([]),
            idType: ko.observable(),
            idItem: ko.observable(),
            options_itemTypes: ko.observableArray([]),
            allItemTypes: ko.observableArray([]),
            idItemType: ko.observable(),
            creationTiming: ko.observable("beginning"),
            options_frequency: ko.observableArray([
                {id: "monthlyEOM", name: "Every Month (End of the month)"},
                {id: "bimonthly", name: "Twice per Month (15 of the month and end of the month)"},
                {id: "quarterly", name: "Every Quarter"},
                {id: "halfYear", name: "Every Half-Year"},
            ]),
            selectedFrequency: ko.observable(),
            options_accounts: ko.observableArray([]),
            allAccounts: ko.observableArray([]),
            idAccount: ko.observable(),
            idBrand: ko.observable(),
            valnetSupportSplit: ko.observable(false),
            showValnetSupportSplit: ko.observable(true),
            options_creationTypes: ko.observableArray([]),
            idCreationType: ko.observable(),
            options_entryTypes: ko.observableArray([]),
            allEntryTypes: ko.observableArray([]),
            idEntryType: ko.observable(),
            idUser: ko.observable(null),
            idUserPaymentClassification: ko.observable(null),
            user: ko.observable(""),
            users: ko.observableArray([]),
            infoTitle: ko.observable("Edit "),
            isEdit: ko.observable(false),
            isShowUserSuggestions: ko.observable(false),
            recurringItemTypesRules : ko.observable(),
            isBrandSelectorShown: ko.observable(false),
            onBlurUser: function (data, event) {
                self.onBlurUser(data, event);
            },
            onClickSave: function (data, event) {
                self.onClickSave();
            },
            onClickCancel: function (data, event) {
                self.onClickCancel();
            },
            onAccountChange: function (data, event) {
                self.onAccountChange();
            },
            onChangeBrand: function (data, event) {
                self.onChangeBrand(data);
            },
            onChangeUserInput: function (data, event) {
                self.onChangeUserInput(event);
            },
            brandPercentage: function (data, event) {
                return self.brandPercentage(data);
            },
            showBrandSelector: function (data, event) {
                self.setIsBrandSelectorShown(true);
            },
            hideBrandSelector: function (data, event) {
                self.setIsBrandSelectorShown(false);
            },
            onChangeValnetDynamicSplit: function(data, event) {
                self.onChangeValnetDynamicSplit();
            }
        };
    }

    //
    // set data functions
    //
    public setCreationTypes(creationTypes: Array<any>) {

        this.getTemplateViewModel().options_creationTypes(creationTypes);
    }

    public setTypes(types: Array<any>) {

        this.getTemplateViewModel().options_types(types);
    }

    public setActionTypes(actionTypes: Array<any>) {

        this.getTemplateViewModel().options_actionTypes(actionTypes);
    }

    public setRoles(roles: Array<any>) {

        this.getTemplateViewModel().options_roles(roles);
    }

    public setAccounts(accounts: Array<any>) {

        this.getTemplateViewModel().options_accounts([]);
        this.getTemplateViewModel().allAccounts(accounts);
    }

    public setEntryTypes(entryTypes: Array<any>) {

        this.getTemplateViewModel().options_entryTypes([]);
        this.getTemplateViewModel().allEntryTypes(entryTypes);
    }

    public setItemTypes(itemTypes: Array<any>) {

        this.getTemplateViewModel().options_itemTypes(itemTypes);
    }

    public setCurrencies(currencies: Array<any>) {

        this.getTemplateViewModel().options_currencies(currencies);
    }

    public setStatus(status: Array<any>) {

        this.getTemplateViewModel().options_status(status);
    }

    public setUsers(users: Array<any>) {
        this.getTemplateViewModel().users(users);
        this.getTemplateViewModel().isShowUserSuggestions(true)
    }

    public setBrandOptions(brands) {

        this.getTemplateViewModel().brands(brands);
    }

    public setAllBrands(brands) {

        this.getTemplateViewModel().allBrands(brands);
        this.limitBrandByCompany(null);
    }

    public setItemOptions(items) {

        this.getTemplateViewModel().options_items(items);
    }

    public setRecurringItemTypesRules(data){
        this.getTemplateViewModel().recurringItemTypesRules(data);
    }


    //
    // set selection functions
    //
    public setSelectedUser(user) {

        if (user) {
            let availableName = this.getSelectAvailableString(user.id, this.getTemplateViewModel().users());
            this.getTemplateViewModel().user(user.valnet_user.fullNameAndLogin + availableName);
            this.getTemplateViewModel().idUser(user.id);
            let effectiveDate = new Date(user.effectiveDate);
            let entryTypes = [];
            let accounts = [];
            let huit_neuf_this = this;
            if(user.idPaymentClassification == 2 && effectiveDate <= new Date()){

                entryTypes = this.getTemplateViewModel().allEntryTypes().filter(function (entry){
                    return huit_neuf_this.allowedPayrollEntryTypes.indexOf(entry.id) >= 0;
                })
                accounts = this.getTemplateViewModel().allAccounts().filter(function (account){
                    return account.id == 4;
                })
            } else {
                entryTypes = this.getTemplateViewModel().allEntryTypes().filter(function (entry){
                    return huit_neuf_this.allowedNonPayrollEntryTypes.indexOf(entry.id) >= 0;
                })
                accounts = this.getTemplateViewModel().allAccounts().filter(function (account){
                    return account.id != 4;
                })
            }
            this.getTemplateViewModel().options_entryTypes(entryTypes);
            this.getTemplateViewModel().options_accounts(accounts);
        }
    }

    protected getSelectAvailableString(id: number, list: any) {
        let found = false;
        for (let c of list) {
            if (c.id == id) {
                found = true;
            }
        }
        // if( !found ){
        //     return " *Not available anymore*";
        // }
        return "";
    }


    public setSelectedType(selectedType: number) {

        this.getTemplateViewModel().idType(selectedType);
    }

    public setSelectedRole(selectedRole: number) {

        this.getTemplateViewModel().idRole(selectedRole);
    }

    public setSelectedFrequency(selectedFrequency: number) {

        this.getTemplateViewModel().selectedFrequency(selectedFrequency);
    }

    public setSelectedItemType(selectedItemType: number) {

        this.getTemplateViewModel().idItemType(selectedItemType);
    }

    public setSelectedActionType(selectedActionType: number) {

        let actionTypeName = this.getTemplateViewModel().options_actionTypes().find(item => item.id === selectedActionType).name;
        this.getTemplateViewModel().actionType(actionTypeName);
        this.getTemplateViewModel().idActionType(selectedActionType);
    }

    public setSelectedEntryType(selectedEntryType: number) {

        this.getTemplateViewModel().idEntryType(selectedEntryType);
    }

    public setRecurringItemType(recurringItemType: number) {

        this.getTemplateViewModel().idRecurringItemType(recurringItemType);
    }

    public setSelectedSalaryType(selectedSalaryType: number) {

        this.getTemplateViewModel().idSalaryType(selectedSalaryType);
    }

    public setSelectedAccount(selectedAccount: number) {

        this.getTemplateViewModel().idAccount(selectedAccount);
    }

    public setSelectedItem(selectedItem: number) {

        this.getTemplateViewModel().idItem(selectedItem);
    }

    public setValnetSupportSplit(valnetSupportSplit: boolean) {

        this.getTemplateViewModel().valnetSupportSplit(valnetSupportSplit);
    }

    public setSelectedBrand(selectedBrand: number) {

        this.getTemplateViewModel().idBrand(selectedBrand);
    }

    public setSelectedCurrency(selectedCurrency: number) {
        let currencyName = this.getTemplateViewModel().options_currencies().find(item => item.id === selectedCurrency).currency;
        this.getTemplateViewModel().currency(currencyName);
        this.getTemplateViewModel().idCurrency(selectedCurrency);
    }


    public setInfoTitle(title) {
        this.getTemplateViewModel().infoTitle(title);
    }

    //
    // user auto complete functions
    //
    protected onBlurUser(data, event) {
        this.getTemplateViewModel().user(data.valnet_user.fullNameAndLogin)
        this.getTemplateViewModel().currency(data.valnet_paymentInfo.currency.currency);
        this.getTemplateViewModel().idCurrency(data.valnet_paymentInfo.currency.id);
        this.getTemplateViewModel().idUser(data.id);
        this.getTemplateViewModel().idUserPaymentClassification(data.id);
        this.getTemplateViewModel().isShowUserSuggestions(false);
        let effectiveDate = new Date(data.effectiveDate);
        let entryTypes = [];
        let accounts = [];
        let huit_neuf_this = this;
        if(data.idPaymentClassification == 2 && effectiveDate <= new Date()){

            entryTypes = this.getTemplateViewModel().allEntryTypes().filter(function (entry){
                return huit_neuf_this.allowedPayrollEntryTypes.indexOf(entry.id) >= 0;
            })
            accounts = this.getTemplateViewModel().allAccounts().filter(function (account){
                return account.id == 4;
            })
        } else {
            entryTypes = this.getTemplateViewModel().allEntryTypes().filter(function (entry){
                return huit_neuf_this.allowedNonPayrollEntryTypes.indexOf(entry.id) >= 0;
            })
            accounts = this.getTemplateViewModel().allAccounts().filter(function (account){
                return account.id != 4;
            })
        }
        this.getTemplateViewModel().options_entryTypes(entryTypes);
        console.log(accounts)
        this.getTemplateViewModel().options_accounts(accounts);

        if(data.idCompany == 1){

            this.getTemplateViewModel().showValnetSupportSplit(true);
        }else{

            this.getTemplateViewModel().showValnetSupportSplit(false);
            this.getTemplateViewModel().valnetSupportSplit(false);
        }

        this.limitBrandByCompany(data);
    }

    protected limitBrandByCompany(user){

        let availableBrands = this.getTemplateViewModel().allBrands();

        if(user && user.idCompany){
            availableBrands = availableBrands.filter(function (value) {

                return value.idCompany == user.idCompany;
            });
        }else{
            availableBrands = [];
        }

        this.setBrandOptions(availableBrands);
    }

    public setSelectedArticle(article: { id: number, title: string }) {

        if (article) {
            let availableName = this.getSelectAvailableString(article.id, this.getTemplateViewModel().articles());
            this.getTemplateViewModel().article(article.title + availableName);
            this.getTemplateViewModel().idItem(article.id);
        }
    }

    protected filterBrandsByAccount() {
        let brands = this.getTemplateViewModel().brands();
        let idAccount = this.getTemplateViewModel().idAccount();

        let newBrands = brands.filter(c => c.idCategory == idAccount);

        this.getTemplateViewModel().options_brands(newBrands);

    }

    protected onChangeArticleInput(event) {
        let input = event.target;
        let inputWrapper = input.parentNode;
        // let closeBtn = inputWrapper.querySelector('#user-input-close');
        // if (!closeBtn.classList.contains('is-showing')) {
        //     closeBtn.classList.add('is-showing');
        // }
        this.onChangeArticleDataListUser(event, this.getTemplateViewModel().idItem);
    }

    protected onChangeArticleDataListUser(event, idItem) {
        let input = event.target,
            inputVal = input.value,
            optionsList = input.getAttribute('list'),
            options: any = document.getElementById(optionsList).childNodes;

        if (inputVal.length >= 3 && event.inputType != undefined) {
            this.caller.getArticlesSuggestion(inputVal);
        }

        for (let op of options) {
            if (op.value === inputVal) {
                idItem(op.id);
                // input.blur();
                // this.caller.filterSimpleOnChange();
                break;
            }
        }

    }

    protected onChangeBrand(data) {
        let idBrand = data.idBrand();
        data.selectedVideoTypes([]);
        this.setVideoTypeOptions(idBrand);
    }


    public setVideoTypeOptions(idBrand) {
        let types = [];
        let videoTypes = this.getTemplateViewModel().videoTypes();

        for (let t of videoTypes) {
            if (t.brand.id == idBrand) {
                types.push(t);
            }
        }
        this.getTemplateViewModel().options_videoTypes(types);
    }


    protected onBlurDataListUser(val, list, id) {

        let found = false;
        let idCurrency = null;

        if (val() != "") {
            console.log(val())
            for (let c of list()) {
                if (c.valnet_user.fullNameAndLogin == val()) {

                    found = true;
                    id(c.id);
                    idCurrency = c.valnet_paymentInfo.idCurrency;
                    break;
                }
            }
        }

        if (!found) {

            id();
            val("");
        }
        if (found) {
            let currencyName = this.getTemplateViewModel().options_currencies().find(item => item.id === idCurrency).currency;
            this.getTemplateViewModel().currency(currencyName);
            this.getTemplateViewModel().idCurrency(idCurrency);
        }
    }

    //
    // save button function
    //
    protected onClickSave() {
        this.caller.saveEditTransaction();
    }

    //
    // cancel button function
    //
    protected onClickCancel() {
        this.caller.cancelEditTransaction();
    }

    public setSelectedBrands(selectedBrands: Array<{ id: number, idBrand: number, percentageAttribution: number }>) {

        let brandsPerc = [];
        let brands = [];
        for (let c of selectedBrands) {
            brands.push(c.idBrand);
            brandsPerc.push({id: c.idBrand, value: c.percentageAttribution})
        }
        this.getTemplateViewModel().selectedBrands(brands);
        this.getTemplateViewModel().selectedBrandsPercentages(brandsPerc);
    }

    public setSelectedVideoTypes(selectedVideoTypes: Array<{ id: number }>) {

        let videoTypes = [];
        for (let c of selectedVideoTypes) {
            videoTypes.push(c.id);
        }
        this.getTemplateViewModel().selectedVideoTypes(videoTypes);
    }

    public setBrands(brands) {

        this.getTemplateViewModel().brands(brands);
    }

    protected onChangeUserInput(event) {
        let input = event.target;
        let inputWrapper = input.parentNode;
        // let closeBtn = inputWrapper.querySelector('#user-input-close');
        // if (!closeBtn.classList.contains('is-showing')) {
        //     closeBtn.classList.add('is-showing');
        // }
        this.onChangeUserDataListUser(event, this.getTemplateViewModel().idUser);
    }

    protected onChangeUserDataListUser(event, idUser) {
        let input = event.target,
            inputVal = input.value,
            optionsList = input.getAttribute('list'),
            options: any = document.getElementById(optionsList).childNodes;

        if (inputVal.length >= 3 && event.inputType != undefined) {
            this.caller.getUsersSuggestion(inputVal);
        }

        for (let op of options) {
            if (op.value === inputVal) {
                idUser(op.id);
                input.blur();
                // this.caller.filterSimpleOnChange();
                break;
            }
        }
    }

    private brandPercentage(data) {

        for (let p of this.getTemplateViewModel().selectedBrandsPercentages()) {
            if (data.id == p.id) {
                return p.value;
            }
        }
    }

    public setIsBrandSelectorShown(isBrandSelectorShown) {
        this.getTemplateViewModel().isBrandSelectorShown(isBrandSelectorShown);
    }

    public onChangeValnetDynamicSplit(){
        // this.caller.get
    }

    public onAccountChange(){

    }

    public showValnetSupportSplit(value : boolean){
        this.getTemplateViewModel().showValnetSupportSplit(value)
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/transactionsRecurringEdit_template.ts